import Background from './Background';
import BackgroundProvider, { useBackground } from './Context';

export default Background;
export { BackgroundProvider, useBackground };
export * from './@hooks';
